import { Grid } from '@/common/grid/Grid';
import { useDependentKey } from '@/common/hooks/key/useDependentKey';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useRef, useState } from 'react';

export const ReallocCalcTable = ({ formValues }) => {

  let { calcId } = formValues;

  const gridRef = useRef();

  const rsrc = useRsrc();

  const [data, setData] = useState(null);

  const [fieldDefs, setFieldDefs] = useState();
  const [isGridReady, setIsGridReady] = useState(false);

  useEffect(() => {

    rsrc.data('gp', 'REALLOC_CALC_TABLE_FIELD_DEFS_DATA_PLUGIN', {}).then(res => {
      setFieldDefs(res);
    });
  }, []);

  useEffect(() => {
    if (!calcId) {
      return;
    }

    const reqParam = {
      calcId
    };

    rsrc.data('gp', 'REALLOC_CALC_TABLE_DATA_PLUGIN', reqParam).then(res => {
      setData(res);
    });

  }, [calcId]);

  const onGridReady = () => {
    setIsGridReady(true);
  };

  useEffect(() => {
    if (isGridReady && gridRef.current && data) {
        gridRef.current.setDataSource(data.rows);
    }
  }, [isGridReady, data]);

  const gridKey = useDependentKey(fieldDefs);

  if (!data) {
    return null;
  }

  return (
    <>
        <Grid
            key={gridKey}
            ref={gridRef}
            gridOptions={{
            fieldDefs,
            rowModelType: 'clientSide',
            statusBar: null
            }}
            events={{ onGridReady }}
        />
    </>

  );
};
